import { useEffect } from 'react';
import cn from 'classnames';
import { Portal } from '@hooks/useCreatePortal';
import { PINNED_FOOTER_ID } from '@components/UI/PinnedContainer/constants';
import { adjustZIndex } from '@components/UI/PinnedContainer/utils';
import styles from './buttonfooter.module.scss';
import { Children } from 'types/base.types';

type ButtonFooterProps = {
  children: Children;
  className?: string;
  noZIndex?: boolean;
  showMobile?: boolean;
  showTablet?: boolean;
  showDesktop?: boolean;
  transparentBG?: boolean;
};

const ButtonFooter = ({
  children,
  className = '',
  noZIndex = false,
  showMobile = true,
  showTablet = true,
  showDesktop = false,
  transparentBG = false,
}: ButtonFooterProps) => {
  const containerStyles = cn(
    'paddingY-small',
    styles.defaultButtonFooter,
    {
      [styles.showMobile]: showMobile,
      [styles.showTablet]: showTablet,
      [styles.showDesktop]: showDesktop,
      [styles.transparent]: transparentBG,
    },
    className,
  );

  useEffect(() => {
    adjustZIndex(noZIndex ? 0 : '');
  }, [noZIndex]);

  useEffect(() => () => adjustZIndex(), []);

  return (
    <Portal id={PINNED_FOOTER_ID}>
      <div className={containerStyles}>{children}</div>
    </Portal>
  );
};

export default ButtonFooter;

/**
  ButtonFooter

  This component will portal into a sticky container in the app layout. See `AppBase/index.tsx`
  and `components/Layout/PinnedContainer` to see its usage.
*/
